
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[courseSlug]",
      function () {
        return require("private-next-pages/course/[courseSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[courseSlug]"])
      });
    }
  